// Tells the app that a page holds edits the user has not saved. A page using it defines
// `unsavedChangesSnapshot()` — what the user can edit, as a plain serializable value — and, if it
// loads its data asynchronously, `unsavedChangesReady()`.
//
// The comparison is against the state at the user's first interaction, not at mount: the page (and
// its children) may still be initializing after mount, and that must not read as an edit. Anything
// the user does starts with one of the events below, which are seen before the edit takes effect.

import { registerUnsavedChanges } from '../utils/unsavedChanges'

const FIRST_INTERACTION_EVENTS = ['mousedown', 'keydown', 'touchstart', 'input', 'change']

export default {
  created() {
    this.$_unsavedChanges_baseline = null
    this.$_unsavedChanges_unregister = registerUnsavedChanges(() => this.hasUnsavedChanges())
    this.$_unsavedChanges_capture = () => {
      if (this.$_unsavedChanges_baseline === null && this.unsavedChangesReady()) {
        this.$_unsavedChanges_baseline = JSON.stringify(this.unsavedChangesSnapshot())
      }
    }
  },

  mounted() {
    // On the document, in the capture phase: modals and popovers are rendered outside the page's
    // element, and the baseline must be taken before the target's own handlers change the state.
    FIRST_INTERACTION_EVENTS.forEach((name) => document.addEventListener(name, this.$_unsavedChanges_capture, true))
  },

  beforeDestroy() {
    FIRST_INTERACTION_EVENTS.forEach((name) => document.removeEventListener(name, this.$_unsavedChanges_capture, true))
    this.$_unsavedChanges_unregister()
  },

  methods: {
    // False while the page is still loading what the user is going to edit.
    unsavedChangesReady() {
      return true
    },

    hasUnsavedChanges() {
      return (
        this.$_unsavedChanges_baseline !== null &&
        JSON.stringify(this.unsavedChangesSnapshot()) !== this.$_unsavedChanges_baseline
      )
    },
  },
}
